import gql from 'graphql-tag';

export const Automation = gql`
  fragment Automation on Automation {
    createdAt
    id
    name
    trigger
    updatedAt
    enabled
  }
`;

export const WorkflowTemplateAutomationAssociation = gql`
  fragment WorkflowTemplateAutomationAssociation on WorkflowTemplateAutomationAssociation {
    automationId
    workflowTemplateId
  }
`;
